import ButtonCustom from '@/components/ButtonCustom'
import { SizeButton } from '@/constants/sizeButton'
import { lightTheme } from '@/customTheme'
import { useEditorContext } from '@/scenes/engine'
import { KeyboardShortcutHint } from '@/scenes/Editor/components/FloatingInspectorButton/SharedComponents/Popover/KeyboardShortcutHint'
import { StyleObject } from 'styletron-react'

type ContextMenuItemProps = {
  startEnhancer?: JSX.Element
  content: string
  endEnhancer?: JSX.Element | string
  handleClick: (e?) => void
  disabled?: boolean
  style?: StyleObject
  fireCanvasEvent?: boolean
}

const ContextMenuItem = ({ startEnhancer, content, endEnhancer, handleClick, disabled = false, style, fireCanvasEvent = true }: ContextMenuItemProps) => {
  const { canvas } = useEditorContext()
  const normalizeEndEnhancer = () => {
    if (!endEnhancer) return null
    if (typeof endEnhancer === 'string') {
      return <KeyboardShortcutHint $disabled={disabled}>{endEnhancer}</KeyboardShortcutHint>
    }
    return endEnhancer
  }
  return (
    <ButtonCustom
      type={SizeButton.STANDARD}
      style={{
        width: '100%',
        padding: '8px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'start',
        ...lightTheme.typography.Small14regular, color: lightTheme.colors.blackGray,
        ...style
      }}
      startEnhancer={startEnhancer}
      endEnhancer={normalizeEndEnhancer()}
      onClick={(e) => {
        handleClick(e)
        if (fireCanvasEvent) canvas.fire('object:modified')
      }}
      disabled={disabled}
    >
      <span style={{...lightTheme.typography.Small14regular, marginRight: '8px', color: disabled ? '#ccc' : lightTheme.colors.blackGray}}>{content}</span>
    </ButtonCustom>
  )
}

export default ContextMenuItem
